export const RainDrop = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 19C24 23.4183 20.4183 27 16 27C11.5817 27 8 23.4183 8 19C8 14.5817 15.5 4.5 16 4C16 4 24 14.5817 24 19Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M20 19C20 21.2091 18.2091 23 16 23" stroke="currentColor" stroke-width="2"/>
</svg>`;
